export default "__VITE_ASSET__DfsKn7T5__"